import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  CONTRACT_AGREEMENT,
  CONTRACT_AGREEMENT_ACCEPT,
  CONTRACT_AGREEMENT_ALL,
  CONTRACT_AGREEMENT_CURRENT,
  CONTRACT_AGREEMENT_OPEN,
  CONTRACT_DOWNLOAD,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const contractSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const contractAgreementSelector = createSelector(contractSelector, data => data[CONTRACT_AGREEMENT])

export const contractAgreementAcceptSelector = createSelector(contractSelector, data => data[CONTRACT_AGREEMENT_ACCEPT])

export const contractAgreementAllSelector = createSelector(contractSelector, data => data[CONTRACT_AGREEMENT_ALL])

export const contractAgreementOpenSelector = createSelector(contractSelector, data => data[CONTRACT_AGREEMENT_OPEN])

export const contractDownloadSelector = createSelector(contractSelector, data => data[CONTRACT_DOWNLOAD])

export const contractAgreementCurrentSelector = createSelector(
  contractSelector,
  data => data[CONTRACT_AGREEMENT_CURRENT]
)
